module.exports = __webpack_public_path__ + "img/hello-black.57ed6cbf.png";